'use client'

import React from 'react'
import Image from 'next/image'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

// ЗАГЛУШКИ: пути к 3 вариантам картинки (десктоп/планшет/моб) — заменить на свои
const imageDesktop = '/images/b2c/easy_of_use_desktop.svg'
const imageTablet = '/images/b2c/easy_of_use_tablet.svg'
const imageMobile = '/images/b2c/easy_of_use_mobile.svg'

const ProcessAutomation: React.FC = () => {
	return (
		<section className={styles.processAutomation}>
			<div className={styles.content}>
				<AnimatedSection animation='slideUp'>
					<div className={styles.subtitle}>Автоматизация процесса</div>
					<h2
						className={styles.title}
						dangerouslySetInnerHTML={{ __html: '<span>От заказа до отгрузки:</span> сокращаем путь сделки <span>с 5 дней до 3 минут</span>' }}
					/>
				</AnimatedSection>
				<AnimatedSection animation='slideUp'>
					<p
						className={styles.description}
						dangerouslySetInnerHTML={{
							__html:
								'Классические межбанковские расчёты между компаниями перегружены ручными действиями с обеих сторон. <span>Сервис True.pay B2B автоматизирует рутину,</span> превращая длинную цепочку согласований в три простых шага со скоростью розничной оплаты.'
						}}
					/>
				</AnimatedSection>
			</div>
			<AnimatedSection animation='slideUp'>
				<div className={styles.visual}>
					<Image
						src={'/images/b2b/automation_desktop.svg'}
						alt='Простая транзакция'
						width={1110}
						height={565}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src={'/images/b2b/automation_tablet.svg'}
						alt='Простая транзакция'
						width={680}
						height={346}
						className={styles.tabletImage}
						unoptimized
					/>
					<Image
						src={'/images/b2b/automation_mobile.svg'}
						alt='Простая транзакция'
						width={328}
						height={1244}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

ProcessAutomation.displayName = 'ProcessAutomation'

export default ProcessAutomation
